// JS for descode changes in add-ons of the cart

// Third-party imports
import $ from 'jquery';

// global arg is expected to be the window object when run in a browser
export function initialize(global) {
    let addonFrequency = '.basketCard--suggestionFooter .field-input';

    // When loaded, change the descode appropriately
    firstLoad(addonFrequency);

    // Detection of descode change
    $(global.document).on('change', addonFrequency, () => {
        updateDescode(this);
    });
}

function firstLoad(location) {
    let count = 0;
    $(location).each(() => {
        if (count % 2 === 1) {
            let value = $(this)
                .find('option:selected')
                .attr('value');
            let mainDes = $(this)
                .parents('.basketCard-inputWrapper')
                .siblings('input[name="properties[des_code]"]');
            if (value === 'SG') {
                let singleDes = $(this)
                    .parents('.basketCard-inputWrapper')
                    .siblings('input[name=des_code_one]')
                    .val();
                mainDes.val(singleDes);
            } else {
                let monthlyDes = $(this)
                    .parents('.basketCard-inputWrapper')
                    .siblings('input[name=des_code_monthly]')
                    .val();
                mainDes.val(monthlyDes);
            }
        }
        count++;
    });
}

function updateDescode(event) {
    let value = $(event)
        .find('option:selected')
        .attr('value');
    let singleDes = $(event)
        .parents('.basketCard-inputWrapper')
        .siblings('input[name=des_code_one]')
        .val();
    let monthlyDes = $(event)
        .parents('.basketCard-inputWrapper')
        .siblings('input[name=des_code_monthly]')
        .val();
    let mainDes = $(event)
        .parents('.basketCard-inputWrapper')
        .siblings('input[name="properties[des_code]"]');
    if (value === null) {
        // do nothing
    } else if (value === 'SG') {
        // if SG then use single descode
        mainDes.val(singleDes);
    } else {
        // if not an SG then use monthly descode
        mainDes.val(monthlyDes);
    }
}
